import React, { useState, useRef } from 'react';
import { Box, Divider, Tab, Tabs, Typography } from '@mui/material';
import { TabContext, TabPanel } from '@mui/lab';
import { CheckList } from '../../../../shared/components';
import { useFetchChecklist } from '../../../stageGates/hooks/useFetchChecklist';
import { FileUploadRef } from '../../../../shared/components/FileUpload';

interface ContractorChecklistDrawerProps {
    stageId: number;
    taskId?: number | null;
}

export const ContractorChecklistDrawer: React.FC<ContractorChecklistDrawerProps> = ({ stageId, taskId }) => {
    const [currentTab, setCurrentTab] = useState('checklist');
    const fileUploadRef = useRef<FileUploadRef | null>(null);

    const { isPending, data } = useFetchChecklist(String(stageId));
    const [selectedChecklistId, setSelectedChecklistId] = useState<string | null>(null);
    const [selectedEditId, setSelectedEditId] = useState<string | null>(null);

    const filteredData = taskId ? data?.filter((item: any) => item.task_id === taskId) : data;

    const handleChangeTab = (_e: React.SyntheticEvent, tab: string) => {
        setCurrentTab(tab);
    };

    if (isPending) {
        return (
            <Box
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                width="100%"
            >
                <Typography>Loading...</Typography>
            </Box>
        );
    }

    return (
        <Box height="100%" display="flex" flexDirection="column">
            <TabContext value={currentTab}>
                <Box display="flex" alignItems="center">
                    <Tabs
                        value={currentTab}
                        onChange={handleChangeTab}
                        aria-label="Tabs"
                        sx={{ minHeight: 'auto' }}
                    >
                        <Tab
                            sx={{ height: 'auto', minHeight: 'auto' }}
                            label="Checklist"
                            value="checklist"
                        />
                    </Tabs>
                </Box>
                <Divider />
                <TabPanel value="checklist" sx={{ p: 2, height: 'calc(100% - 50px)', overflowY: 'auto', flex: 1 }}>
                    {filteredData?.length === 0 ? (
                        <Typography>No checklist items</Typography>
                    ) : (
                        <Box display="flex" flexDirection="column" gap={2}>
                            {filteredData?.map(
                                (item: {
                                    task_id: string;
                                    status: 'completed' | 'in_progress' | 'not_started';
                                    task_name: string;
                                    owner: string;
                                    updated_at: string;
                                    is_required: boolean;
                                    is_evidence_required: boolean;
                                }) => (
                                    <CheckList
                                        key={item.task_id}
                                        completedStatus={item.status}
                                        title={item.task_name}
                                        owner={item.owner}
                                        completedDate={item.updated_at}
                                        downloadLink={'sample link'}
                                        isRequired={item.is_required}
                                        isEvidenceRequired={item.is_evidence_required}
                                        isLoading={false}
                                        fileUploadRef={fileUploadRef}
                                        checkListId={item.task_id}
                                        checklistType="stageGate"
                                        allowAttachmentComplete={true}
                                        onSave={() => {}}
                                        onUploadComplete={() => {}}
                                        selectedChecklistId={selectedChecklistId}
                                        setSelectedChecklistId={setSelectedChecklistId}
                                        selectedEditId={selectedEditId}
                                        setSelectedEditId={setSelectedEditId}
                                        
                                        
                                    />
                                )
                            )}
                        </Box>
                    )}
                </TabPanel>
            </TabContext>
        </Box>
    );
};
